module.exports = __webpack_public_path__ + "img/service_banner.6fbc5b08.jpg";